import { postRequest } from '@/utils/request';
import { getRecruitHost } from '@/utils/utils';

// 接口文档 http://wiki.wx.xunlei.cn/pages/viewpage.action?pageId=109478416
// const host = getRecruitHost();
// let host;
// getRecruitHost().then(h => {
//   host = h;
// });

// 申请参与接口
export async function postApply(data) {
  const host = await getRecruitHost();
  return postRequest(`${host}/v2/recruit-resource/apply`, data);
}

// 重新验收接口
export async function postReApply(data) {
  const host = await getRecruitHost();
  return postRequest(`${host}/v3/recruit/device/re_accept`, data);
}

//  结果查询接口
export async function getApplyResult(data) {
  const host = await getRecruitHost();
  return postRequest(`${host}/v1/recruit-resource/application-result`, data);
}

// 获取过滤条件
export async function getFilter(data) {
  const host = await getRecruitHost();
  return postRequest(`${host}/v1/recruit-resource/get-filter`, data);
}

// 获取定向招募列表
export async function getRecruitList(data) {
  const host = await getRecruitHost();
  return postRequest(`${host}/v1/recruit-resource/recruit-list`, data);
}

// 定向业务招募  获取定向招募业务规则
export async function getRecruitBizRules(data) {
  const host = await getRecruitHost();
  return postRequest(`${host}/v2/recruit-resource/recruit-biz-rules`, data);
}

// 获取招募业务tab列表
export async function getRecruitBizTabs(data) {
  const host = await getRecruitHost();
  return postRequest(`${host}/v2/recruit-resource/recruit-biz-list`, data);
}

// 获取结果过滤条件
export async function getResultFilter(data) {
  const host = await getRecruitHost();
  return postRequest(`${host}/v1/recruit-resource/get-result-filter`, data);
}

// 标记tab已读
export async function setBizTabRead(data) {
  const host = await getRecruitHost();
  return postRequest(`${host}/v2/recruit-resource/recruit-biz-read`, data);
}

// x86上机流程优化新增接口，文档:http://wiki.wx.xunlei.cn/pages/viewpage.action?pageId=145719455
// 获取招募业务筛选条件
export async function getBizFilterOptions(data) {
  const host = await getRecruitHost();
  return postRequest(`${host}/v2/recruit-resource/recruiting-biz-config`, data);
}

export async function getBizInfoList(data) {
  const host = await getRecruitHost();
  return postRequest(`${host}/v2/recruit-resource/recruiting-biz-list`, data);
}
